import React from "react";

const Footer = () => (
  <footer className="bg-light p-3 text-center">© 2025 All rights reserved.</footer>
);

export default Footer;
